import { KalTableEventManager } from './kal-table-event-manager';


export enum KalTableSortDirection {
    DESC = 'desc',
    ASC = 'asc'
}

export class KalTableSortEvent {
    code: string;
    direction: KalTableSortDirection;
    customComparator?: (sort: KalTableSortEvent) => (a, b) => number;
    valueAccessor?: (row, code) => string | number;
}

export class KalTableSortManager extends KalTableEventManager<KalTableSortEvent> {

}
